import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getServer } from "../consts";

const albumsApi = createApi({
  reducerPath: "albums",
  baseQuery: fetchBaseQuery({ baseUrl: getServer() }),
  endpoints: (builder) => {
    return {
      fetchAlbums: builder.query({
        query: (user) => {
          return {
            url: `albums/`,
            method: "GET",
            params: { usrId: user.id },
          };
        },
        providesTags: (result, error, user) => {
          return [{ type: "Album", id: user.id }];
        },
      }),
      addAlbums: builder.mutation({
        query: (album) => {
          return { url: `albums`, method: "POST", body: { ...album } };
        },
        invalidatesTags: (result, error, album) => {
          return [{ type: "Album", id: album.usrId }];
        },
      }),
      deleteAlbum: builder.mutation({
        query: (album) => {
          return { url: `albums/${album.id}`, method: "DELETE" };
        },
        invalidatesTags: (result, error, album) => {
          return [{ type: "Album", id: album.usrId }];
        },
      }),
    };
  },
});

const { useFetchAlbumsQuery, useAddAlbumsMutation, useDeleteAlbumMutation } =
  albumsApi;
export {
  albumsApi,
  useFetchAlbumsQuery,
  useAddAlbumsMutation,
  useDeleteAlbumMutation,
};
